import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useNavigate } from "react-router-dom";
import { useLoginContext } from "../context/LoginContext";
import VarificationStatusModal from "../Modal/VarificationStatusModal";

export default function Settings() {
  const Navigate = useNavigate();
  const { userData, refresh } = useLoginContext();
  const [show, setShow] = useState(false)
  const [submitType, setSubmitType] = useState("")
  const handleShow = (type) => {
    setShow(true)
    setSubmitType(type)
  }
  const handleClose = () => {
    setShow(false)
    setSubmitType("")
  }

  useEffect(() => {
    refresh();
  }, []);

  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3>Account</h3>
            <Row className="create-new-step">
              <Col lg={8}>
                <div className="settings-card-contain">
                  <div className="settings-cart-title">
                    <h4>Profile</h4>
                    <ul>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/my-profile")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M8.22197 19.352C6.4535 20.405 1.8167 22.5552 4.64083 25.2458C6.02039 26.56 7.55687 27.5 9.48859 27.5H20.5114C22.4431 27.5 23.9796 26.56 25.3591 25.2458C28.1833 22.5552 23.5465 20.405 21.778 19.352C17.631 16.8827 12.369 16.8827 8.22197 19.352Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M20.625 8.125C20.625 11.2316 18.1066 13.75 15 13.75C11.8934 13.75 9.375 11.2316 9.375 8.125C9.375 5.0184 11.8934 2.5 15 2.5C18.1066 2.5 20.625 5.0184 20.625 8.125Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                            />
                          </svg>
                        </div>
                        <p>My Profile</p>
                      </li>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/reviews")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M17.1595 4.30522L19.3592 8.7411C19.6592 9.35858 20.4591 9.95087 21.1341 10.0643L25.1211 10.7322C27.6709 11.1607 28.2709 13.0257 26.4335 14.8656L23.3339 17.9909C22.8089 18.5201 22.5215 19.5409 22.6839 20.2719L23.5714 24.1406C24.2712 27.2029 22.6589 28.3875 19.9717 26.787L16.2346 24.5565C15.5597 24.1532 14.4474 24.1532 13.7599 24.5565L10.0228 26.787C7.34812 28.3875 5.72331 27.1902 6.42324 24.1406L7.31064 20.2719C7.47311 19.5409 7.18565 18.5201 6.6607 17.9909L3.56105 14.8656C1.73625 13.0257 2.32369 11.1607 4.8734 10.7322L8.86046 10.0643C9.52289 9.95087 10.3228 9.35858 10.6228 8.7411L12.8225 4.30522C14.0224 1.89826 15.9721 1.89826 17.1595 4.30522Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <p>Reviews</p>
                      </li>
                      <li
                        className="cursor-pointer"
                        onClick={() => {
                          if (userData?.verificationStatus == "Unverified") {
                            Navigate("/get-verified")
                          } else if (userData?.verificationStatus == "Pending") {
                            handleShow("Pending")
                          } else if (userData?.verificationStatus == "Declined") {
                            handleShow("Declined")
                          }else{
                            
                            handleShow("Approved")
                          }
                        }}
                      >
                        <div>

                          {userData?.verificationStatus == "Approved" ?
                                 <svg
                                 xmlns="http://www.w3.org/2000/svg"
                                 width="35"
                                 height="35"
                                 viewBox="0 0 27 27"
                                 fill="none"
                               >
                                 <rect
                                   width="25"
                                   height="25"
                                   rx="12.5"
                                   transform="matrix(-1 0 0 1 26 1)"
                                   fill="#337FE0"
                            
                                 />
                                 <path
                                   d="M20.0001 10L11.7066 16.8581L8 13.2486"
                                   stroke="white"
                                   stroke-width="2"
                                   stroke-linecap="round"
                                   stroke-linejoin="round"
                                 />
                               </svg> :
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                              fill="none"
                            >
                              <path
                                d="M23.7381 23.75H23.75M23.7381 23.75C22.9597 24.5219 21.5491 24.3296 20.5599 24.3296C19.3456 24.3296 18.7609 24.5671 17.8943 25.4338C17.1564 26.1718 16.1671 27.5 15 27.5C13.8329 27.5 12.8436 26.1718 12.1057 25.4338C11.2391 24.5671 10.6544 24.3296 9.44008 24.3296C8.45085 24.3296 7.04023 24.5219 6.26186 23.75C5.47726 22.972 5.67035 21.5555 5.67035 20.5599C5.67035 19.3018 5.3952 18.7232 4.49923 17.8272C3.16643 16.4945 2.50002 15.828 2.5 15C2.50001 14.1719 3.1664 13.5055 4.49919 12.1727C5.299 11.3729 5.67035 10.5804 5.67035 9.44008C5.67035 8.45081 5.47811 7.04017 6.25 6.2618C7.02804 5.47722 8.4445 5.67033 9.4401 5.67033C10.5803 5.67033 11.3729 5.299 12.1727 4.49921C13.5055 3.1664 14.1719 2.5 15 2.5C15.8281 2.5 16.4945 3.1664 17.8272 4.49921C18.6269 5.29884 19.4194 5.67033 20.5599 5.67033C21.5491 5.67033 22.9599 5.47809 23.7383 6.25C24.5228 7.02804 24.3296 8.44449 24.3296 9.44008C24.3296 10.6982 24.6049 11.2767 25.5008 12.1727C26.8336 13.5055 27.5 14.1719 27.5 15C27.5 15.828 26.8336 16.4945 25.5008 17.8272C24.6048 18.7232 24.3296 19.3018 24.3296 20.5599C24.3296 21.5555 24.5227 22.972 23.7381 23.75Z"
                                stroke="#202020"
                                strokeWidth="1.875"
                              />
                              <path
                                d="M11.25 16.1161L13.5 18.125L18.75 11.875"
                                stroke="#202020"
                                strokeWidth="1.875"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>

                          }


                        </div>
                        {userData?.verificationStatus == "Approved" ? <p>Verified</p> :  <p>Verification</p>}
                      </li>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/premium-memberships")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M4.39773 12.8823C3.91266 11.5397 3.67012 10.8684 3.77355 10.4383C3.88666 9.96784 4.22125 9.60105 4.64891 9.4787C5.03991 9.36683 5.64816 9.63716 6.86466 10.1778C7.94066 10.6561 8.47866 10.8952 8.98415 10.8819C9.54071 10.8672 10.0761 10.6441 10.502 10.2491C10.8888 9.89046 11.1483 9.31891 11.6672 8.1758L12.8107 5.65656C13.766 3.55219 14.2436 2.5 15 2.5C15.7564 2.5 16.234 3.55219 17.1892 5.65656L18.3329 8.1758C18.8517 9.31891 19.1112 9.89046 19.498 10.2491C19.9239 10.6441 20.4592 10.8672 21.0159 10.8819C21.5214 10.8952 22.0594 10.6561 23.1354 10.1778C24.3519 9.63716 24.9601 9.36683 25.3511 9.4787C25.7787 9.60105 26.1134 9.96784 26.2265 10.4383C26.3299 10.8684 26.0874 11.5397 25.6022 12.8821L23.5172 18.6528C22.6252 21.1213 22.1794 22.3555 21.246 23.0527C20.3127 23.75 19.1067 23.75 16.6947 23.75H13.3052C10.8932 23.75 9.68721 23.75 8.75393 23.0527C7.82067 22.3555 7.37471 21.1213 6.48277 18.6528L4.39773 12.8823Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                            />
                            <path
                              d="M15 17.5H15.0112"
                              stroke="#202020"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M8.75 27.5H21.25"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                            />
                          </svg>
                        </div>
                        <p>Premium</p>
                      </li>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/account-details")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M17.5 11.25H22.5"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                            />
                            <path
                              d="M17.5 15.625H21.25"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                            />
                            <path
                              d="M21.25 3.75H8.75C5.29822 3.75 2.5 6.54822 2.5 10V20C2.5 23.4518 5.29822 26.25 8.75 26.25H21.25C24.7018 26.25 27.5 23.4518 27.5 20V10C27.5 6.54822 24.7018 3.75 21.25 3.75Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M6.25 20C7.76039 16.7736 13.3903 16.5614 15 20"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M13.125 11.25C13.125 12.6306 12.0057 13.75 10.625 13.75C9.24429 13.75 8.125 12.6306 8.125 11.25C8.125 9.86929 9.24429 8.75 10.625 8.75C12.0057 8.75 13.125 9.86929 13.125 11.25Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                            />
                          </svg>
                        </div>
                        <p>Account Details</p>
                      </li>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/account-security")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M11.25 16.25C11.25 16.25 12.5 16.25 13.75 18.75C13.75 18.75 17.7206 12.5 21.25 11.25"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M26.25 13.9791V10.3504C26.25 8.30036 26.25 7.27535 25.7449 6.60661C25.2397 5.93786 24.0976 5.6132 21.8134 4.96388C20.2528 4.52025 18.877 3.98579 17.7779 3.49786C16.2792 2.83262 15.53 2.5 15 2.5C14.47 2.5 13.7207 2.83262 12.2221 3.49786C11.123 3.98579 9.7473 4.52024 8.18666 4.96388C5.90241 5.6132 4.76027 5.93786 4.25514 6.60661C3.75 7.27535 3.75 8.30036 3.75 10.3504V13.9791C3.75 21.0106 10.0785 25.2294 13.2425 26.8992C14.0014 27.2997 14.3807 27.5 15 27.5C15.6193 27.5 15.9986 27.2997 16.7575 26.8992C19.9215 25.2294 26.25 21.0106 26.25 13.9791Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                            />
                          </svg>
                        </div>
                        <p>Security</p>
                      </li>
                    </ul>
                  </div>
                  <div className="settings-cart-title">
                    <h4>Lead Settings</h4>
                    <ul>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/your-services")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="26"
                            viewBox="0 0 20 26"
                            fill="none"
                          >
                            <path
                              d="M5.78517 13.842H5.21147C3.35681 13.842 2.42947 13.842 2.0342 13.2305C1.63892 12.6191 2.01555 11.7673 2.7688 10.0635L5.03335 4.94154C5.71821 3.3925 6.06065 2.61797 6.72496 2.18399C7.38927 1.75 8.23237 1.75 9.91875 1.75H12.5305C14.579 1.75 15.6032 1.75 15.9895 2.41919C16.3759 3.08838 15.8677 3.98235 14.8514 5.77029L13.5115 8.12735C13.0062 9.01619 12.7536 9.46061 12.7571 9.8244C12.7617 10.2972 13.0131 10.7327 13.4192 10.9712C13.7317 11.1549 14.2409 11.1549 15.2592 11.1549C16.5466 11.1549 17.1904 11.1549 17.5256 11.3777C17.9611 11.6672 18.1891 12.1852 18.1092 12.704C18.0477 13.1032 17.6147 13.582 16.7487 14.5396L9.82987 22.1904C8.47087 23.6931 7.79137 24.4445 7.33509 24.2068C6.87879 23.9689 7.09791 22.9778 7.53612 20.9953L8.39462 17.112C8.72825 15.6025 8.89512 14.8478 8.49387 14.3449C8.09262 13.842 7.32346 13.842 5.78517 13.842Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <p>Your Services</p>
                      </li>
                    </ul>
                  </div>
                  <div className="settings-cart-title">
                    <h4>Notifications</h4>
                    <ul>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/contact-preferences")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M25.625 6.875H11.875C7.2334 6.875 3.75 10.2313 3.75 15"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M4.375 23.125H18.125C22.7666 23.125 26.25 19.7688 26.25 15"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M23.125 3.75C23.125 3.75 26.25 6.05153 26.25 6.87503C26.25 7.69853 23.125 10 23.125 10"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M6.87497 20C6.87497 20 3.75001 22.3015 3.75 23.125C3.74999 23.9485 6.875 26.25 6.875 26.25"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <p>Update Settings</p>
                      </li>

                      <li
                        onClick={() => Navigate("/refer")}
                        style={{ cursor: "pointer" }}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M26.25 8.125C26.25 10.1961 24.5711 11.875 22.5 11.875C20.4289 11.875 18.75 10.1961 18.75 8.125C18.75 6.05394 20.4289 4.375 22.5 4.375C24.5711 4.375 26.25 6.05394 26.25 8.125Z"
                              stroke="#141B34"
                              strokeWidth="1.875"
                            />
                            <path
                              d="M11.25 15C11.25 17.0711 9.57106 18.75 7.5 18.75C5.42894 18.75 3.75 17.0711 3.75 15C3.75 12.9289 5.42894 11.25 7.5 11.25C9.57106 11.25 11.25 12.9289 11.25 15Z"
                              stroke="#141B34"
                              strokeWidth="1.875"
                            />
                            <path
                              d="M26.25 21.875C26.25 23.9461 24.5711 25.625 22.5 25.625C20.4289 25.625 18.75 23.9461 18.75 21.875C18.75 19.8039 20.4289 18.125 22.5 18.125C24.5711 18.125 26.25 19.8039 26.25 21.875Z"
                              stroke="#141B34"
                              strokeWidth="1.875"
                            />
                            <path
                              d="M10.9106 13.4369L19.0356 9.6875M10.9106 16.5625L19.0356 20.3119"
                              stroke="#141B34"
                              strokeWidth="1.875"
                            />
                          </svg>
                        </div>
                        <p> Refer a Friend</p>
                      </li>
                    </ul>
                  </div>
                  <div className="settings-cart-title">
                    <h4>Quote Credits & Payments</h4>
                    <ul>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/credits")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M2.5 15C2.5 10.5781 2.5 8.36721 3.816 6.89112C4.02649 6.65504 4.25848 6.43669 4.50933 6.23859C6.07766 5 8.42678 5 13.125 5H16.875C21.5732 5 23.9224 5 25.4906 6.23859C25.7415 6.43669 25.9735 6.65504 26.184 6.89112C27.5 8.36721 27.5 10.5781 27.5 15C27.5 19.4219 27.5 21.6328 26.184 23.1089C25.9735 23.345 25.7415 23.5632 25.4906 23.7614C23.9224 25 21.5732 25 16.875 25H13.125C8.42678 25 6.07766 25 4.50933 23.7614C4.25848 23.5632 4.02649 23.345 3.816 23.1089C2.5 21.6328 2.5 19.4219 2.5 15Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M12.5 20H14.375"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M18.125 20H22.5"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M2.5 11.25H27.5"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <p>Quote Credits </p>
                      </li>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/invoices")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M5 23.3072V10.0678C5 6.50031 5 4.71656 6.09835 3.60829C7.1967 2.5 8.96446 2.5 12.5 2.5H17.5C21.0355 2.5 22.8032 2.5 23.9016 3.60829C25 4.71656 25 6.50031 25 10.0678V23.3072C25 25.1969 25 26.1416 24.4225 26.5135C23.4789 27.1214 22.0201 25.8468 21.2864 25.3841C20.6801 25.0018 20.3771 24.8106 20.0406 24.7996C19.6771 24.7876 19.3686 24.971 18.7136 25.3841L16.325 26.8905C15.6806 27.2967 15.3585 27.5 15 27.5C14.6415 27.5 14.3194 27.2967 13.675 26.8905L11.2864 25.3841C10.6802 25.0018 10.3771 24.8106 10.0407 24.7996C9.67715 24.7876 9.36866 24.971 8.71359 25.3841C7.97994 25.8468 6.52109 27.1214 5.57744 26.5135C5 26.1416 5 25.1969 5 23.3072Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M13.75 13.75H10"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M17.5 8.75H10"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <p>Invoices</p>
                      </li>
                      <li
                        className="cursor-pointer"
                        onClick={() => Navigate("/your-subscription")}
                      >
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M3.1624 18.462C2.89659 20.2045 4.085 21.414 5.54006 22.0167C11.1185 24.3277 18.8815 24.3277 24.4599 22.0167C25.915 21.414 27.1034 20.2045 26.8376 18.462C26.6743 17.3911 25.8665 16.4994 25.268 15.6286C24.4841 14.4741 24.4063 13.2147 24.4061 11.875C24.4061 6.69733 20.1949 2.5 15 2.5C9.80516 2.5 5.59391 6.69733 5.59391 11.875C5.59379 13.2147 5.5159 14.4741 4.73201 15.6286C4.13355 16.4994 3.32576 17.3911 3.1624 18.462Z"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M10 23.75C10.5731 25.9065 12.5944 27.5 15 27.5C17.4056 27.5 19.4269 25.9065 20 23.75"
                              stroke="#202020"
                              strokeWidth="1.875"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <p>Subscribe</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <div className="setting-buy-more">
                  <p>
                    You have{" "}
                    {userData?.wallet?.quotes ? userData?.wallet?.quotes : 0}{" "}
                    quotes remaining{" "}
                  </p>
                  <button
                    className="theme-comm-btn"
                    onClick={() => Navigate("/credits")}
                  >
                    Buy More
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </Container>

        <VarificationStatusModal
          show={show}
          handleClose={handleClose} 
          type={submitType}
        />
      </Layout>
    </>
  );
}
